<script>
import { connect } from 'vuex-connect';
import ControlsBoxGame from '../scenes/ControlsBoxGame.vue';

export default connect({
  gettersToProps: {
    game: 'playingGame',
  },
  stateToProps: {
    loading: state => state.launcher.loadings.getStation,
  },
})('ControlsBoxGame', ControlsBoxGame);
</script>
